import { queryOptions, useQuery } from '@tanstack/react-query';

import { ListAuthTokensRequest } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

export const API_ACCESS_KEYS_QUERY_KEY = 'api-access-keys';

const getApiAccessKeysQueryKey = (params: {
  organizations?: ListAuthTokensRequest['organizations'];
}) => [API_ACCESS_KEYS_QUERY_KEY, params.organizations] as const;

const getApiAccessKeysQueryOptions = ({
  organizations = 'ALL',
}: {
  organizations?: ListAuthTokensRequest['organizations'];
} = {}) =>
  queryOptions({
    queryKey: getApiAccessKeysQueryKey({ organizations }),
    queryFn: () => apiClient.accessKeys.getApiAccessKeys({ organizations }),
    select: ({ data }) => data.items,
  });

export const useApiAccessKeysQuery = (
  organizations: ListAuthTokensRequest['organizations'] = 'ALL'
) => {
  const { isLoading, data, isSuccess, error, refetch } = useQuery(
    getApiAccessKeysQueryOptions({ organizations })
  );

  return {
    isLoading,
    isSuccess,
    apiAccessKeys: data || undefined,
    error,
    refetch,
  };
};
